import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const SectionHeading = ({ chapter, eyebrow, title, description, dark = false, testid }) => (
    <div className="max-w-3xl" data-testid={testid}>
        <Reveal>
            <p className={`text-xs font-bold uppercase tracking-[0.25em] ${dark ? "text-brand-green-light" : "text-brand-green"}`}>
                {chapter && <span className={dark ? "text-white/40" : "text-slate-400"}>{chapter}&nbsp;&nbsp;·&nbsp;&nbsp;</span>}
                {eyebrow}
            </p>
        </Reveal>
        <Reveal delay={0.1}>
            <h2 className={`mt-5 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1] ${dark ? "text-white" : "text-brand-blue"}`}>
                {title}
            </h2>
        </Reveal>
        {description && (
            <Reveal delay={0.2}>
                <p className={`mt-6 text-base md:text-lg leading-relaxed ${dark ? "text-white/70" : "text-slate-600"}`}>{description}</p>
            </Reveal>
        )}
    </div>
);
